// Post-login intro choreography — shared arm/disarm state.
//
// Login arms the intro just before navigating; the Header and DashboardGrid
// read it on mount to decide whether to play their entrance animations, and
// the grid disarms it once the choreography finishes. Module state (not
// storage) on purpose: the intro plays exactly once per login, never on
// reloads or later dashboard visits.

let armed = false;

export const armIntro = () => {
  armed = true;
};

export const isIntroArmed = () => armed;

export const disarmIntro = () => {
  armed = false;
};

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  !!window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

// True when the full intro should play right now.
export const shouldPlayIntro = () => armed && !prefersReducedMotion();
